export const toggleNotifications = () => ({
  type: "TOGGLE_NOTIFICATIONS",
});

export const getCurrentProperty = (obj) => ({
  type: "GET_CURRENT_PROPERTY",
  obj,
});

export const getCurrentPropertySuccess = (data) => ({
  type: "GET_CURRENT_PROPERTY_SUCCESS",
  data,
});

export const getCurrentPropertyFail = (error) => ({
  type: "GET_CURRENT_PROPERTY_FAIL",
  error,
});

export const resetCurrentProperty = () => ({
  type: "RESET_CURRENT_PROPERTY",
});

export const getProperties = (obj) => ({
  type: "GET_PROPERTIES",
  obj,
});

export const getPropertiesSuccess = (data) => ({
  type: "GET_PROPERTIES_SUCCESS",
  data,
});

export const getPropertiesFail = (error) => ({
  type: "GET_PROPERTIES_FAIL",
  error,
});

export const getRegisteredProperties = (obj) => ({
  type: "GET_REGISTERED_PROPERTIES",
  obj,
});

export const getRegisteredPropertiesSuccess = (data) => ({
  type: "GET_REGISTERED_PROPERTIES_SUCCESS",
  data,
});

export const getRegisteredPropertiesFail = (error) => ({
  type: "GET_REGISTERED_PROPERTIES_FAIL",
  error,
});

export const getMlProperties = (obj) => ({
  type: "GET_ML_PROPERTIES",
  obj,
});

export const getMlPropertiesSuccess = (data) => ({
  type: "GET_ML_PROPERTIES_SUCCESS",
  data,
});

export const getMlPropertiesFail = (error) => ({
  type: "GET_ML_PROPERTIES_FAIL",
  error,
});
export const getMlEngineProperties = (obj) => ({
  type: "GET_ML_ENGINE_PROPERTIES",
  obj,
});

export const getMlEnginePropertiesSuccess = (data) => ({
  type: "GET_ML_ENGINE_PROPERTIES_SUCCESS",
  data,
});

export const getMlEnginePropertiesFail = (error) => ({
  type: "GET_ML_ENGINE_PROPERTIES_FAIL",
  error,
});

export const getNotificationCount = () => ({
  type: "GET_NOTIFICATION_COUNT",
});

export const getNotificationCountSuccess = (data) => ({
  type: "GET_NOTIFICATION_COUNT_SUCCESS",
  data,
});

export const getNotificationCountFail = (error) => ({
  type: "GET_NOTIFICATION_COUNT_FAIL",
  error,
});

export const incrementNotificationCount = () => ({
  type: "INCREMENT_NOTIFICATION_COUNT",
});

export const decrementNotificationCount = () => ({
  type: "DECREMENT_NOTIFICATION_COUNT",
});

export const getCircles = (obj) => ({
  type: "GET_CIRCLES",
  obj,
});

export const getCirclesSuccess = (data) => ({
  type: "GET_CIRCLES_SUCCESS",
  data,
});

export const getCirclesFail = (error) => ({
  type: "GET_CIRCLES_FAIL",
  error,
});

export const resetMlPropertiesCount = () => ({
  type: "RESET_ML_PROPERTIES_COUNT",
});

export const setPropertyApproval = (obj) => ({
  type: "SET_PROPERTY_APPROVAL",
  obj,
});

export const setPropertyApprovalSuccess = (data) => ({
  type: "SET_PROPERTY_APPROVAL_SUCCESS",
  data,
});

export const setPropertyApprovalFail = (error) => ({
  type: "SET_PROPERTY_APPROVAL_FAIL",
  error,
});

export const prioritizeProperty = (obj) => ({
  type: "PRIORITIZE_PROPERTY",
  obj,
});

export const prioritizePropertySuccess = (data) => ({
  type: "PRIORITIZE_PROPERTY_SUCCESS",
  data,
});

export const prioritizePropertyFail = (error) => ({
  type: "PRIORITIZE_PROPERTY_FAIL",
  error,
});

export const searchProperties = (obj) => ({
  type: "SEARCH_PROPERTIES",
  obj,
});

export const searchPropertiesSuccess = (data) => ({
  type: "SEARCH__PROPERTIES_SUCCESS",
  data,
});

export const searchPropertiesFail = (error) => ({
  type: "SEARCH__PROPERTIES_FAIL",
  error,
});

export const resetSearchedProperties = () => ({
  type: "RESET_SEARCHED_PROPERTIES",
});

export const getNotifications = (obj) => ({
  type: "GET_NOTIFICATIONS",
  obj,
});

export const getNotificationsSuccess = (data) => ({
  type: "GET_NOTIFICATIONS_SUCCESS",
  data,
});

export const getNotificationsFail = (error) => ({
  type: "GET_NOTIFICATIONS_FAIL",
  error,
});

export const getRegisteredPropertiesPercentagesByZone = (obj) => ({
  type: "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE",
  obj,
});

export const getRegisteredPropertiesPercentagesByZoneSuccess = (data) => ({
  type: "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE_SUCCESS",
  data,
});

export const getRegisteredPropertiesPercentagesByZoneFail = (error) => ({
  type: "GET_REGISTERED_PROPERTIES_PERCENTAGES_BYZONE_FAIL",
  error,
});

export const getTiDetails = (obj) => ({
  type: "GET_TI_DETAILS",
  obj,
});

export const getTiDetailsSuccess = (data) => ({
  type: "GET_TI_DETAILS_SUCCESS",
  data,
});

export const getTiDetailsFail = (error) => ({
  type: "GET_TI_DETAILS_FAIL",
  error,
});

export const getTiPropertStats = (obj) => ({
  type: "GET_TI_PROPERTY_STATS",
  obj,
});

export const getTiPropertStatsSuccess = (data) => ({
  type: "GET_TI_PROPERTY_STATS_SUCCESS",
  data,
});

export const getTiPropertStatsFail = (error) => ({
  type: "GET_TI_PROPERTY_STATS_FAIL",
  error,
});

export const getLookupTableData = (obj) => ({
  type: "GET_LOOKUP_TABLE_DATA",
  obj,
});

export const getLookupTableDataSuccess = (data) => ({
  type: "GET_LOOKUP_TABLE_DATA_SUCCESS",
  data,
});

export const getLookupTableDataFail = (error) => ({
  type: "GET_LOOKUP_TABLE_DATA_FAIL",
  error,
});

export const setPropertyDetail = (data) => ({
  type: "SET_PROPERTY_DETAIL",
  data,
});

export const resetPropertyDetail = () => ({
  type: "RESET_PROPERTY_DETAIL",
});

export const updatePropertyDetail = (obj) => ({
  type: "UPDATE_PROPERTY_DETAIL",
  obj,
});

export const updatePropertyDetailSuccess = (data) => ({
  type: "UPDATE_PROPERTY_DETAIL_SUCCESS",
  data,
});

export const updatePropertyDetailFail = (error) => ({
  type: "UPDATE_PROPERTY_DETAIL_FAIL",
  error,
});

export const resetPropertyDetailResponse = (error) => ({
  type: "RESET_PROPERTY_DETAIL_RESPONSE",
  error,
});

export const getUploadLookupData = (obj) => ({
  type: "GET_UPLOAD_LOOKUP_DATA",
  obj,
});

export const getUploadLookupDataSuccess = (data) => ({
  type: "GET_UPLOAD_LOOKUP_DATA_SUCCESS",
  data,
});

export const getUploadLookupDataFail = (error) => ({
  type: "GET_UPLOAD_LOOKUP_DATA_FAIL",
  error,
});

export const fetchLookupReport = (obj) => ({
  type: "FETCH_LOOKUP_REPORT",
  obj,
});

export const fetchLookupReportSuccess = (data) => ({
  type: "FETCH_LOOKUP_REPORT_SUCCESS",
  data,
});

export const fetchLookupReportFail = (error) => ({
  type: "FETCH_LOOKUP_REPORT_FAIL",
  error,
});

export const resetFetchLookupReport = () => ({
  type: "RESET_FETCH_LOOKUP_REPORT",
});

export const fetchRegisteredProperty = (obj) => ({
  type: "FETCH_REGISTERED_PROPERTY",
  obj,
});

export const fetchRegisteredPropertySuccess = (data) => ({
  type: "FETCH_REGISTERED_PROPERTY_SUCCESS",
  data,
});

export const fetchRegisteredPropertyFail = (error) => ({
  type: "FETCH_REGISTERED_PROPERTY_FAIL",
  error,
});

export const fetchUnRegisteredProperty = (obj) => ({
  type: "FETCH_UNREGISTERED_PROPERTY",
  obj,
});

export const fetchUnRegisteredPropertySuccess = (data) => ({
  type: "FETCH_UNREGISTERED_PROPERTY_SUCCESS",
  data,
});

export const fetchUnRegisteredPropertyFail = (error) => ({
  type: "FETCH_UNREGISTERED_PROPERTY_FAIL",
  error,
});

export const getFilterMetaData = (obj) => ({
  type: "GET_FILTER_META_DATA",
  obj,
});

export const getFilterMetaDataSuccess = (data) => ({
  type: "GET_FILTER_META_DATA_SUCCESS",
  data,
});

export const getFilterMetaDataFail = (error) => ({
  type: "GET_FILTER_META_DATA_FAIL",
  error,
});

export const getLatestDataFile = (obj) => ({
  type: "GET_LATEST_DATA_FILE",
  obj,
});

export const getLatestDataFileSuccess = (data) => ({
  type: "GET_LATEST_DATA_FILE_SUCCESS",
  data,
});

export const getLatestDataFileFail = (error) => ({
  type: "GET_LATEST_DATA_FILE_FAIL",
  error,
});

export const getDcRateHistory = (obj) => ({
  type: "GET_DC_RATE_HISTORY",
  obj,
});

export const getDcRateHistorySuccess = (data) => ({
  type: "GET_DC_RATE_HISTORY_SUCCESS",
  data,
});

export const getDcRateHistoryFail = (error) => ({
  type: "GET_DC_RATE_HISTORY_FAIL",
  error,
});
